import React from "react";
import { motion } from "framer-motion";
import {
  Award,
  BookOpen,
  Briefcase,
  GraduationCap,
  Users,
  Building2,
  Target,
  Mic,
  Presentation,
  Star
} from "lucide-react";

import icanLogo from "../assets/ican logo.webp";
import dangoteLogo from "../assets/dangote logo.png";
import nbcLogo from "../assets/nbc logo.webp";
import eyLogo from "../assets/ey logo.png";
import citnLogo from "../assets/citn logo.webp";
import switLogo from "../assets/swit logo.webp";
import bovasLogo from "../assets/bovas logo.webp";
import elanLogo from "../assets/elan logo.webp";

const About = () => {
  // const fadeInUp = {
  //   initial: { opacity: 0, y: 20 },
  //   animate: { opacity: 1, y: 0 },
  //   transition: { duration: 0.6 }
  // };

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-blue-50">
      <div className="container mx-auto px-4 pt-32 md:pt-40 pb-16">
        {/* Professional Summary Section */}
        <motion.section
          className="mb-16"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-3xl font-bold text-gray-800 mb-6 flex items-center gap-3">
            <Briefcase className="text-yellow-600" />
            Professional Summary
          </h2>
          <div className="bg-white rounded-xl shadow-lg p-6 md:p-8">
            <p className="text-gray-700 leading-relaxed mb-4">
              Oyeka Amara  is a seasoned public finance expert and a bsuiness strategist who was
              recently appointed by The Governor of Anambra State as The Executive Director,
              Direct Tax at the Anambra Internal Revenue Service (AIRS); as she stepped down from
              the role of  Senior Special Assistant on Internally Generated Revenue (SSA–IGR
              Technical) to Anambra Government.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              Her career in tax administration began at the Ogun State Internal Revenue Service
              (OGIRS), where she spent three years honing her skills before moving to the Lagos
              State Internal Revenue Service (LIRS). Over the course of 12 years at LIRS, she rose to
              the position of Tax Manager, demonstrating exceptional leadership and technical
              expertise that paved the way for her transition into public service as a political
              appointee.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              Amara holds a B.Sc. in Accounting from the University of Nigeria, Nsukka (UNN)
              Enugu State, and an M.Sc. in Corporate Finance from Babcock University, Ogun State.
              She is a Fellow of the Institute of Chartered Accountants of Nigeria (ICAN), the
              Chartered Institute of Taxation of Nigeria (CITN), and the Chartered Institute of
              Public Finance and Accountancy (CIPFA-UK). She is also an associate member of
              Women in Management, Business and Public Service (WIMBIZ), reflecting her
              commitment to advancing the course of women in leadership.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              With over 17 years of experience spanning tax audit, finance, accounting, tax
              technology, and strategic administration, Amara is widely respected for her
              contributions to both the public and private sectors. She is a passionate mentor and
              advocate for gender equity, which led her to establish the Obele Women
              Empowerment Foundation (OWEF)—a platform dedicated to uplifting women
              through education, entrepreneurship, and community engagement. Her passion for
              impact also finds expression in her role as a regular speaker and facilitator, where she
              shares insights on taxation, business strategy, leadership, finance, mentorship and
              empowerment.
            </p>
            <p className="text-gray-700 leading-relaxed">
              In addition to her public service, Amara is a dynamic entrepreneur; who most recently
              founder an online market place for B2B, B2C and C2C calld Uru. She leads corporate
              services as Executive Director at SIGNALHOUSE GROUP, serves as Founder and
              Lead Mentor at Led2Lead Consulting Limited, and is the MD/CEO of Seagreen
              Media Limited. Her influence extends into professional development and
              governance, where she serves as Team Lead for the Management Information (MI)
              subject in ICAN examinations and contributes as a Subject Matter Expert (SME) in
              taxation to ICAN Members’ Continuous Professional Development (MCPD)
              brochure—a role she has held for over seven years. She is also a board member who
              currently chairs four steering committees focused on organizational strategy and
              governance.           </p>
          </div>
        </motion.section>

        {/* Current Roles Section */}
        <motion.section
          className="mb-16"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.8 }}
        >
          <h2 className="text-3xl font-bold text-gray-800 mb-6 flex items-center gap-3">
            <Building2 className="text-yellow-600" />
            Current Leadership Roles
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <motion.div
              className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow"
              whileHover={{ scale: 1.02 }}
            >
              <h3 className="text-xl font-semibold text-yellow-600 mb-3">Executive Positions</h3>
              <ul className="space-y-3 text-gray-700">
                <li>• Executive Director at SIGNALHOUSE GROUP</li>
                <li>• Founder and Lead Mentor at Led2Lead Consulting Limited</li>
                <li>• MD/CEO at Seagreen Media Limited</li>
                <li>• SSA-IGR Technical to Anambra State Governor</li>
                <li>• Founder/President of Obele Women Empowerment
                  Foundation (OWEF)</li>
                <li>• Executive Director, Direct Tax AIRS</li>
                <li>• Founder, Uru </li>
              </ul>
            </motion.div>
            <motion.div
              className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow"
              whileHover={{ scale: 1.02 }}
            >
              <h3 className="text-xl font-semibold text-yellow-600 mb-3">Professional Leadership</h3>
              <ul className="space-y-3 text-gray-700">
                <li>• Team Lead for Management Information (MI) - ICAN</li>
                <li>• Subject Matter Expert (SME) in taxation</li>
                <li>• Chair of 4 steering committees on organizational strategies</li>
                <li>• MCPD contributor for over 6 years</li>
                <li>• Team Lead: Management Information on Paper of ICAN exams</li>
                <li>• Subject matter Expert (SME) Tax Practice Sector, ICAN</li>
                <li>• Research Collaborator with Wheeler Institute for Business and Development</li>
                <li>• MCPD contributor over 7years</li>
                <li>• Volunteer at NESG</li>
              </ul>
            </motion.div>
          </div>
        </motion.section>

        {/* Education & Certifications */}
        <motion.section
          className="mb-16"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.8 }}
        >
          <h2 className="text-3xl font-bold text-gray-800 mb-6 flex items-center gap-3">
            <GraduationCap className="text-yellow-600" />
            Education & Certifications
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <motion.div
              className="bg-white rounded-xl shadow-lg p-6"
              whileHover={{ scale: 1.02 }}
            >
              <h3 className="text-xl font-semibold text-yellow-600 mb-3">Education</h3>
              <ul className="space-y-4 text-gray-700">
                <li className="flex items-start gap-3">
                  <BookOpen className="mt-1 text-yellow-600 flex-shrink-0" />
                  <div>
                    <p className="font-semibold">M.Sc. Corporate Finance</p>
                    <p>Babcock University, Ilishan-Remo Ogun State</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <BookOpen className="mt-1 text-yellow-600 flex-shrink-0" />
                  <div>
                    <p className="font-semibold">B.Sc. Accounting</p>
                    <p>University of Nigeria Nsukka, Enugu Campus (UNEC)</p>
                  </div>
                </li>
              </ul>
            </motion.div>
            <motion.div
              className="bg-white rounded-xl shadow-lg p-6"
              whileHover={{ scale: 1.02 }}
            >
              <h3 className="text-xl font-semibold text-yellow-600 mb-3">Professional Memberships</h3>
              <ul className="space-y-4 text-gray-700">
                <li className="flex items-start gap-3">
                  <Award className="mt-1 text-yellow-600 flex-shrink-0" />
                  <div>
                    <p className="font-semibold">Fellow (FCA)</p>
                    <p>Institute of Chartered Accountants of Nigeria (ICAN)</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <Award className="mt-1 text-yellow-600 flex-shrink-0" />
                  <div>
                    <p className="font-semibold">Fellow (FCTI)</p>
                    <p>Chartered Institute of Taxation of Nigeria (CITN)</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <Users className="mt-1 text-yellow-600 flex-shrink-0" />
                  <div>
                    <p className="font-semibold">Associate Member</p>
                    <p>Women in Management, Business and Public Service (WIMBIZ)</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <Users className="mt-1 text-yellow-600 flex-shrink-0" />
                  <div>
                    <p className="font-semibold">Associate (CPFA-UK)</p>
                    <p>Chartered Institute of Public Finance and Accountancy (CIPFA)</p>
                  </div>
                </li>
              </ul>
            </motion.div>
          </div>
        </motion.section>

        {/* Key Skills & Expertise */}
        <motion.section
          className="mb-16"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.8 }}
        >
          <h2 className="text-3xl font-bold text-gray-800 mb-6 flex items-center gap-3">
            <Target className="text-yellow-600" />
            Key Skills & Expertise
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {[
              "Tax Strategy & Audit",
              "Financial Management",
              "Leadership Development",
              "Corporate Governance",
              "Strategic Planning",
              "Business Consulting",
              "Mentorship",
              "Public Speaking"
            ].map((skill, index) => (
              <motion.div
                key={skill}
                className="bg-white rounded-lg shadow-md p-4 text-center"
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.1 * index }}
                whileHover={{ scale: 1.05 }}
              >
                <p className="text-gray-700 font-medium">{skill}</p>
              </motion.div>
            ))}
          </div>
        </motion.section>

        {/* Speaking Engagements */}
        <motion.section
          className="mb-16"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.7, duration: 0.8 }}
        >
          <h2 className="text-3xl font-bold text-gray-800 mb-6 flex items-center gap-3">
            <Mic className="text-yellow-600" />
            Speaking Engagements for Organizations
          </h2>
          <div className="bg-white rounded-xl shadow-lg p-8 overflow-hidden relative">
            {/* Gradient Overlays for smooth edges */}
            <div className="absolute inset-y-0 left-0 w-20 bg-gradient-to-r from-white to-transparent z-10"></div>
            <div className="absolute inset-y-0 right-0 w-20 bg-gradient-to-l from-white to-transparent z-10"></div>

            <motion.div 
              className="flex gap-12 items-center"
              animate={{ 
                x: [0, -1600] 
              }}
              transition={{ 
                duration: 30, 
                repeat: Infinity, 
                ease: "linear" 
              }}
            >
              {[
                { name: "ICAN", src: icanLogo },
                { name: "DANGOTE", src: dangoteLogo },
                { name: "NIGERIA BOTTLING COMPANY", src: nbcLogo },
                { name: "EY", src: eyLogo },
                { name: "CITN", src: citnLogo },
                { name: "SWIT", src: switLogo },
                { name: "BOVAS GROUP", src: bovasLogo },
                { name: "ELAN", src: elanLogo },
                // Duplicate for seamless loop
                { name: "ICAN", src: icanLogo },
                { name: "DANGOTE", src: dangoteLogo },
                { name: "NIGERIA BOTTLING COMPANY", src: nbcLogo },
                { name: "EY", src: eyLogo },
                { name: "CITN", src: citnLogo },
                { name: "SWIT", src: switLogo },
                { name: "BOVAS GROUP", src: bovasLogo },
                { name: "ELAN", src: elanLogo },
              ].map((org, index) => (
                <div key={index} className="flex flex-col items-center gap-3 min-w-[160px] transition-all duration-500">
                  <div className="h-16 flex items-center justify-center">
                    <img 
                      src={org.src} 
                      alt={org.name} 
                      className="max-h-full max-w-[120px] object-contain"
                    />
                  </div>
                  <span className="font-bold text-[10px] text-gray-400 uppercase tracking-widest text-center">{org.name}</span>
                </div>
              ))}
            </motion.div>
          </div>
        </motion.section>

        {/* Conferences Spoken At & Featured In */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16">
          {/* Conferences */}
          <motion.section
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.8, duration: 0.8 }}
          >
            <h2 className="text-3xl font-bold text-gray-800 mb-6 flex items-center gap-3">
              <Presentation className="text-yellow-600" />
              Conferences Spoken At
            </h2>
            <div className="bg-white rounded-xl shadow-lg p-6 h-full">
              <ul className="space-y-4 text-gray-700">
                {[
                  "She Thrives Conference",
                  "Global Giant Girls Conference",
                  "ICAN Southeast Conference",
                  "She Means Business Conference"
                ].map((conf, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <div className="w-2 h-2 rounded-full bg-yellow-600 mt-2 flex-shrink-0"></div>
                    <span className="font-medium text-lg leading-tight">{conf}</span>
                  </li>
                ))}
              </ul>
            </div>
          </motion.section>

          {/* Featured In */}
          <motion.section
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.9, duration: 0.8 }}
          >
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6 flex items-center gap-3">
              <Star className="text-yellow-600" />
              Featured In
            </h2>
            <div className="bg-white rounded-xl shadow-lg p-6 h-full">
              <ul className="space-y-6 text-gray-700">
                <li className="flex items-start gap-4">
                  <Star className="text-yellow-600 mt-1 flex-shrink-0 fill-yellow-600" size={24} />
                  <div>
                    <h4 className="font-bold text-lg md:text-xl text-gray-800 leading-tight">Her Network</h4>
                    <p className="text-sm md:text-base text-gray-600 mt-1">Outstanding work with Governance and Social impact</p>
                  </div>
                </li>
                <li className="flex items-start gap-4">
                  <Star className="text-yellow-600 mt-1 flex-shrink-0 fill-yellow-600" size={24} />
                  <div>
                    <h4 className="font-bold text-lg md:text-xl text-gray-800 leading-tight">SWIT</h4>
                    <p className="text-sm md:text-base text-gray-600 mt-1">Distinguished female tax administrator</p>
                  </div>
                </li>
                <li className="flex items-start gap-4">
                  <Star className="text-yellow-600 mt-1 flex-shrink-0 fill-yellow-600" size={24} />
                  <div>
                    <h4 className="font-bold text-lg md:text-xl text-gray-800 leading-tight">WIMBIZ</h4>
                    <p className="text-sm md:text-base text-gray-600 mt-1">Women in Management, Business and Public Service</p>
                  </div>
                </li>
              </ul>
            </div>
          </motion.section>
        </div>
      </div>
    </div>
  );
};

export default About;